import _ from 'lodash'
import moment from 'moment'
import 'moment-timezone'

export class DateUtilService {
    static floorDate(date) {
        let timezone = moment.tz.guess(true)
        return moment
            .tz(
                moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                timezone
            )
            .format()
    }

    static ceilingDate(date) {
        let timezone = moment.tz.guess(true)
        return moment
            .tz(
                moment(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                timezone
            )
            .format()
    }

    static isValidDateTime(dateTimeStr) {
        if (dateTimeStr instanceof Date) {
            return !isNaN(dateTimeStr.getTime())
        }

        if (_.isNil(dateTimeStr) || _.isEmpty(dateTimeStr)) {
            return false
        }
        var date = new Date(dateTimeStr)
        return date instanceof Date && !isNaN(date.getTime())
    }

    static getMomentInTimeZone(dateTimeStr) {
        return moment.tz(dateTimeStr, moment.tz.guess(true))
    }

    static isAfterToday(dateToCheck) {
        return DateUtilService.getMomentInTimeZone(dateToCheck).isAfter(
            DateUtilService.getMomentInTimeZone(),
            'day'
        )
    }

    static isAfter(dateToCheck, dateToCompareWith) {
        let timezone = DateUtilService.getMomentInTimeZone(dateToCheck)
        let timezonecompare =
            DateUtilService.getMomentInTimeZone(dateToCompareWith)
        return timezone.isAfter(timezonecompare)
    }

    static checkDateInBrowserTimeZone(dateTimeStr) {
        const MIN_YEAR = 1900
        // year should be valid and 4 digit to get correct timezone offset from moment.
        if (!dateTimeStr || moment(dateTimeStr).year() < MIN_YEAR) {
            return true
        }
        let browserTimeZone = moment(dateTimeStr)
            .tz(moment.tz.guess(true))
            .format('Z')
        let inputDateTimeZone = moment(dateTimeStr).format('Z')
        return browserTimeZone === inputDateTimeZone
    }

    static formatDate = (date) => {
        return (
            moment(date).format('YYYY-MM-DD') +
            ' ' +
            moment(date).format('HH:mm a')
        )
    }

    static toDisplayTime(dateTimeStr, format = 'DD-MMM-yyyy') {
        return DateUtilService.getDateStringInLocalTimeZone(dateTimeStr, format)
    }

    static getDateStringInLocalTimeZone(dateTimeStr, displayFormat) {
        if (!dateTimeStr || !DateUtilService.isValidDateTime(dateTimeStr)) {
            return ''
        }

        let newDateTime = DateUtilService.getMomentInTimeZone(dateTimeStr)

        if (displayFormat) {
            return newDateTime.format(displayFormat)
        }
        return newDateTime.format()
    }

    static prepareDateStringForApiCall(dateTimeStrInBrowserTimezone) {
        if (
            !dateTimeStrInBrowserTimezone ||
            !DateUtilService.isValidDateTime(dateTimeStrInBrowserTimezone)
        ) {
            return ''
        }

        return `${moment(dateTimeStrInBrowserTimezone)
            .tz(moment.tz.guess(true))
            .format('dd/MM/yyyy')}${moment(dateTimeStrInBrowserTimezone)
            .tz(
                DateUtilService.getMomentInTimeZone(
                    dateTimeStrInBrowserTimezone
                )
            )
            .format('Z')}`
    }

    static formatToCurrency = (amount) => {
        if (!amount) {
            return ''
        }
        return parseFloat(amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    }
}
